import { interfaces } from 'inversify';
import { useInjection } from 'inversify-react';

export type AsyncHookResult<R = void, E = string> = {
  result?: R;
  inProgress: boolean;
  error?: E;
};
export type InjectableHook<T extends object> = () => T;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useHookInjection<T extends InjectableHook<any>>(
  identifier: interfaces.ServiceIdentifier<T>,
): ReturnType<T> {
  return useInjection<T>(identifier)();
}
